import { z } from "zod";
import { KPI_STATUSES } from "@playbookai/types";
import { ShortText } from "./common.js";
/**
 * Strategic Health — a row of top-line transformation stat cards. Each card
 * stores the **semantic** status via `z.enum(KPI_STATUSES)`; the consuming
 * design system maps status → tone/colour at render (ADR-0014, data-blind).
 * The seeded cards live in the mock layer; `defaultParams` is an empty skeleton.
 */
/**
 * Bounded allow-list of per-stat icon names (DB-01). The design system maps
 * each name → a Lucide icon at render; keeping it an enum (not free text)
 * stops arbitrary icon strings from reaching the widget.
 */
export const STRATEGIC_HEALTH_ICONS = [
    "target",
    "trendingDown",
    "alertOctagon",
    "clock",
    "gitBranch",
];
const StrategicHealthStatSchema = z
    .object({
    label: ShortText,
    value: ShortText,
    trend: ShortText,
    status: z.enum(KPI_STATUSES),
    iconName: z.enum(STRATEGIC_HEALTH_ICONS).optional(),
})
    .strict();
export const StrategicHealthParamsSchema = z
    .object({
    stats: z.array(StrategicHealthStatSchema).optional(),
})
    .strict();
export const defaultStrategicHealthParams = {
    stats: [],
};
//# sourceMappingURL=strategicHealth.js.map